import { Component, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { UpaPluginsModel } from '../../models';
import { StartUpConfigUiService } from '../../Services';

@Component({
  selector: 'ras-upa-plugins',
  templateUrl: './upa-plugins.component.html'
})
export class UpaPluginsComponent implements OnInit {

  @Input() isWS: boolean = false;

  private upaPlugings: UpaPluginsModel
  constructor(private startUpConfigUiService: StartUpConfigUiService) { }

  ngOnInit() {
    this.startUpConfigUiService.deferredConfig$.pipe(take(1)).subscribe({
      next: (deferredConfig) => {
        this.upaPlugings = deferredConfig.upaPluginsModel;

        if (!this.upaPlugings)
          return;

        if (this.upaPlugings.isEnabled) {
          this.initLoginTrigger(this.upaPlugings.settings.upaLoginTriggerPlugin)
          this.initLogin(this.upaPlugings.settings.upaLoginPlugin)
        }
      }
    });
  }

  initLoginTrigger(loginTiggerPlugin) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.innerHTML = '';
      script.src = loginTiggerPlugin;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve('success - postload');
      }
      script.onerror = () => {
        reject('error');
      };
      document.head.appendChild(script);
    });
  }

  initLogin(loginPlugin) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.innerHTML = '';
      script.src = loginPlugin;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve('success - postload');
      }
      script.onerror = () => {
        reject('error');
      };
      document.head.appendChild(script);
    });
  }

}
